import {Col, Row } from "antd";
import React from "react";

import { GENERAL_APPLICATION_LINK, GENERAL_JOB_BOARD_LINK } from "../constants";

import { NoSearchImage } from "./NoSearchImage";
import { NoSearchActionCol, NoSearchButton, NoSearchCenteredCol, NoSearchMessageLine, NoSearchTitle } from "./styled";
import { NoSearchResultsProps } from "./types";


export const NoSearchResults: React.FC<NoSearchResultsProps> = ({
  queryDispatch,
  allowReset,
  showActions,
  message = "Sorry, we couldn't find any openings matching your search.",
}) => (
  <Row justify="center" gutter={32} className="fadeInFast">
    <NoSearchCenteredCol span={24}>
      <NoSearchImage />
    </NoSearchCenteredCol>
    <Col span={24}>
      <NoSearchTitle level={2}>
        {Array.isArray(message)
          ? message.map((line, index) => (
              <NoSearchMessageLine
                key={index}
                isLast={index === message.length - 1}
              >
                {line}
                <br />
              </NoSearchMessageLine>
            ))
          : message}
      </NoSearchTitle>
    </Col>

    {showActions && (
      <>
        <NoSearchActionCol span={24}>
          <NoSearchButton
            href={GENERAL_APPLICATION_LINK}
            type="primary"
            target="_blank"
          >
            {"Submit a general application"}
          </NoSearchButton>
        </NoSearchActionCol>
        <NoSearchActionCol span={24}>
          {allowReset ? (
            <NoSearchButton
              type="primary"
              ghost={true}
              onClick={() =>
                queryDispatch({
                  type: "reset",
                })
              }
            >
              {"Reload the job board"}
            </NoSearchButton>
          ) : (
            <NoSearchButton
              href={GENERAL_JOB_BOARD_LINK}
              type="primary"
              ghost={true}
              target="_blank"
            >
              {"Search all openings"}
            </NoSearchButton>
          )}
        </NoSearchActionCol>
      </>
    )}
  </Row>
);
